const RoadBlockIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 30'
        width={size}
        height={(size * 30) / 24}
      >
        <path
          d='M10,5A3,3,0,1,0,7,8,3,3,0,0,0,10,5ZM7,6A1,1,0,1,1,8,5,1,1,0,0,1,7,6Z'
          fill='currentColor'
        />
        <path
          d='M20,5a3,3,0,1,0-3,3A3,3,0,0,0,20,5ZM17,6a1,1,0,1,1,1-1A1,1,0,0,1,17,6Z'
          fill='currentColor'
        />
        <path
          d='M20,8H2v8H4v6H6V20H18v2h2V16h2V8Zm-5.88,2h3.76l-2,4H12.12Zm-6,0h3.76l-2,4H6.12ZM4,13.76V10H5.88ZM18,18H6V16H18Zm2-4H18.12L20,10.24Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};

export default RoadBlockIcon;
